import React, { JSX } from 'react';
import { LivenessErrorContent } from '@/model/LivenessErrorContent';

interface StateProps {
  livenessErrorContent?: LivenessErrorContent;
}

interface DispatchProps {
  backScreen: () => void;
}

type Props = StateProps & DispatchProps;

export const FaceLivenessError: React.FC<Props> = ({
  livenessErrorContent,
  backScreen,
}): JSX.Element => (
  <div className="event w-full container mx-auto mb-36 lg">
    <div className="flex flex-col items-center text-center">
      <div className="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-600">
        <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true">
          <path
            d="M18 6L6 18M6 6l12 12"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h2 id="liveness-error-title" className="text-lg font-semibold">
        {livenessErrorContent?.title}
      </h2>
      <p className="mt-1 text-sm text-gray-600">{livenessErrorContent?.message}</p>
      {/* <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Tip
            icon="💡"
            title="Boa iluminação"
            text="Fique de frente para a luz (evite luz atrás de você)."
          />
          <Tip icon="🧢" title="Sem acessórios" text="Remova boné, óculos escuros e máscaras." />
          <Tip
            icon="📱"
            title="Enquadre o rosto"
            text="Centralize o rosto e mantenha o celular na altura dos olhos."
          />
          <Tip icon="🧍" title="Fundo neutro" text="Prefira um fundo liso e sem estampas." />
          <Tip
            icon="🎥"
            title="Movimentos"
            text="Siga os movimentos solicitados (ex.: olhar para os lados)."
          />
          <Tip icon="🔇" title="Ambiente calmo" text="Evite tremer; segure firme o aparelho." />
        </div> */}
    </div>
    <button
      onClick={backScreen}
      className="mt-6 w-full rounded-xl bg-gray-600 py-3 text-white transition hover:bg-gray-700 active:scale-[0.99]"
    >
      Tentar novamente
    </button>
  </div>
);
